import React from "react";
import { IEducationId } from "../../Education.props";
import EditEducation from "./EditEducation";

const EditEducationIndex: React.FC<IEducationId> = ({ educationId ,name }) => {
  return <EditEducation educationId={educationId} name={name} />;
};

export default EditEducationIndex;
